import { CloseIcon } from './customIcons';

import type { OverWritable } from '../../@types/settings';

export const chip: OverWritable = {
  MuiChip: {
    defaultProps: {
      deleteIcon: CloseIcon,
    },

    styleOverrides: {
      root: ({ theme }) => ({
        ...theme.typography.body3,
        borderRadius: theme.shape.borderRadius,
      }),
      outlined: ({ theme }) => ({
        borderColor: theme.palette.grey[500_32],
        '&.MuiChip-colorPrimary': {
          borderColor: theme.palette.primary.main,
        },
        '&.MuiChip-colorSecondary': {
          borderColor: theme.palette.secondary.main,
        },
      }),
      avatar: ({ theme }) => ({
        fontSize: theme.typography.subtitle2.fontSize,
        fontWeight: theme.typography.subtitle2.fontWeight,
      }),
      /**
       * the following are added props by the zone template
       */
      // colorDefault: {
      //   color: theme.palette.text.secondary,
      //   "& .MuiChip-avatarMedium, .MuiChip-avatarSmall": {
      //     color: theme.palette.text.secondary,
      //   },
      // },
      // avatarColorInfo: ( { theme } ) => (
      //   {
      //     color: theme.palette.info.contrastText,
      //     backgroundColor: theme.palette.info.dark,
      //   }
      // ),
      // avatarColorSuccess: ( { theme } ) => (
      //   {
      //     color: theme.palette.success.contrastText,
      //     backgroundColor: theme.palette.success.dark,
      //   }
      // ),
      // avatarColorWarning: ( { theme } ) => (
      //   {
      //     color: theme.palette.warning.contrastText,
      //     backgroundColor: theme.palette.warning.dark,
      //   }
      // ),
      // avatarColorError: ( { theme } ) => (
      //   {
      //     color: theme.palette.error.contrastText,
      //     backgroundColor: theme.palette.error.dark,
      //   }
      // ),
    },
  },
};
